import { t } from 'i18next';
import { NODE_CATEGORIES } from '../../../../../constants/workflow.constant';
import { getNodeFormIds, findUpstreamNodeIds } from '../utils/graphHelpers';

const collectUpstreamSubmissionFormIds = (nodeId, nodes, edges) => {
  const upstreamNodeIds = findUpstreamNodeIds(nodeId, edges);
  const formIds = new Set();
  for (const id of upstreamNodeIds) {
    const node = nodes.find((n) => n.id === id);
    if (node?.category === NODE_CATEGORIES.SUBMISSION) {
      getNodeFormIds(node).forEach((fId) => formIds.add(fId));
    }
  }
  return formIds;
};

export const validateFormReviewCoverage = (nodes) => {
  const submissionNodes = nodes.filter(
    (node) => node.category === NODE_CATEGORIES.SUBMISSION
  );
  const reviewNodes = nodes.filter(
    (node) => node.category === NODE_CATEGORIES.REVIEW
  );

  const submittedFormIds = new Set();
  for (const node of submissionNodes) {
    getNodeFormIds(node).forEach((id) => submittedFormIds.add(id));
  }

  const reviewedFormIds = new Set();
  for (const node of reviewNodes) {
    getNodeFormIds(node).forEach((id) => reviewedFormIds.add(id));
  }

  for (const formId of submittedFormIds) {
    if (!reviewedFormIds.has(formId)) {
      const submissionNode = submissionNodes.find((n) =>
        getNodeFormIds(n).includes(formId)
      );
      const formNames = submissionNode?.data?.formConfig?.form_names || {};
      const formName = formNames[formId] || `Form ${formId}`;

      return {
        message: t('workflowValidation.reviewStageAssignedRequired', {
          formName,
        }),
      };
    }
  }

  return null;
};

const validateNodeFormOrder = (targetNodes, nodes, edges) => {
  for (const node of targetNodes) {
    const nodeName = node.data?.formConfig?.name || node.id;
    const nodeFormIds = getNodeFormIds(node);

    if (nodeFormIds.length === 0) continue;

    const upstreamFormIds = collectUpstreamSubmissionFormIds(
      node.id,
      nodes,
      edges
    );

    for (const formId of nodeFormIds) {
      if (!upstreamFormIds.has(formId)) {
        return {
          message: t('workflowValidation.reviewOrderError', {
            reviewName: nodeName,
          }),
        };
      }
    }
  }

  return null;
};

export const validateReviewFormOrder = (nodes, edges) => {
  const reviewNodes = nodes.filter(
    (node) => node.category === NODE_CATEGORIES.REVIEW
  );
  return validateNodeFormOrder(reviewNodes, nodes, edges);
};

export const validateAssessmentReviewFormOrder = (nodes, edges) => {
  const assessmentReviewNodes = nodes.filter(
    (node) => node.category === NODE_CATEGORIES.ASSESSMENT_REVIEW
  );
  return validateNodeFormOrder(assessmentReviewNodes, nodes, edges);
};

export const validateSingleAssessmentReviewStage = (nodes) => {
  const assessmentReviewNodes = nodes.filter(
    (node) => node.category === NODE_CATEGORIES.ASSESSMENT_REVIEW
  );
  if (assessmentReviewNodes.length > 1) {
    return { message: t('workflowValidation.singleAssessmentReviewOnly') };
  }
  return null;
};
